<se-fe-modal #modal [seFeDataActions]="modalButtons" (seFeClose)="onClose()">

  <div seFeModalHeader>
    <se-fe-modal-header
      seFeDataTitle="Grant Access">
    </se-fe-modal-header>
  </div>

  <div seFeModalContent>
    @if (error) {
      <se-fe-alert
        seFeDataType="error"
        >
        {{ error }}
      </se-fe-alert>
    }
    <div>
      <p>Grant access to {{ persona?.first_name }}'s information and help manage their sports life by inviting someone.</p>
    </div>
    <se-po-add-guardian #addGuardian>
    </se-po-add-guardian>
  </div>

</se-fe-modal>
<se-fe-toast></se-fe-toast>
